<template>
	<v-card>
		<v-toolbar flat>
			<v-toolbar-title class="mr-3">Esposa</v-toolbar-title>
			<v-spacer/>
			<v-btn
				color="primary"
				type="button"
				text
				@click="incluirRemoverEsposa"
			> {{ irmao.esposa ? 'Remover' : 'Incluir' }} Esposa </v-btn>
		</v-toolbar>
		<v-container fluid>
			<v-row v-if="irmao.esposa">
				<v-col cols="12" sm="6" lg="12">
					<v-text-field
						label="Nome*"
						v-model="irmao.esposa.nome"
						:rules="[ obrigatorio ]"
						required
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="12">
					<v-text-field
						label="Profissão"
						v-model="irmao.esposa.profissao"
					/>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { authModule } from '../../../store'
import { InputIrmao } from '../../../../common/types/Irmao'
import { obrigatorio } from '../../../shareds/regras'
import { intersectRoles } from '../../../helpers/auth-helpers'
import { criarEsposa } from '../../../shareds/sharedsIrmao'

const props = defineProps({
	value: { type: Object as PropType<InputIrmao>, required: true },
})

const emit = defineEmits<{
	(e: 'input', irmao: InputIrmao): void
}>()

const irmao = computed(() => props.value)

function incluirRemoverEsposa() {
	emit('input', {
		...irmao.value,
		esposa: irmao.value.esposa
			? null
			: criarEsposa(),
	})
}
</script>
